import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "./Components/Layout";
import Home from "./pages/Home";
import Redirect from "./pages/Redirect";
import Serp from "./pages/Serp";
import { URLRedirectHandler } from "./shared/utils/URLRedirectHandler";
import { AppDownloadGate } from "./Components/organisms/AppDownloadGate";
import { useEffect, useState } from "react";
import AuthCallback from "./pages/AuthCallback";
import AccountPage from "./pages/Account";
import DeleteAccountRequestPage from "./pages/DeleteAccountRequest";
import { RequireAuth } from "./shared/components/RequireAuth";
import EditAlertPage from "./pages/Alerts/EditAlert";
import AlertsListPage from "./pages/AlertsV2";
import AlertsCreatePage from "./pages/AlertsV2/Create";
import { useZoomScrollContainer } from "./shared/components/ZoomWrapper/ZoomWrapper";

export default function App() {
  const location = useLocation();
  const [shouldRender, setShouldRender] = useState(false);
  const scrollContainer = useZoomScrollContainer();

  // biome-ignore lint/correctness/useExhaustiveDependencies: reavalia o SERP a cada mudança de rota ou query string
  useEffect(() => {
    const path = window.location.pathname;

    const match = path.match(
      /^\/passagens-aereas-de-([^/]+)\/([^/]+)\/para-([^/]+)\/([^/]+)$/,
    );

    const hasQueryParams = window.location.search.includes("origin-airport");

    if (match && hasQueryParams) {
      setShouldRender(true);
    } else {
      setShouldRender(false);
    }
  }, [location.pathname, location.search]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: rola ao topo a cada mudança de rota
  useEffect(() => {
    scrollContainer?.current?.scrollTo(0, 0);
    window.scrollTo(0, 0);
  }, [location.pathname, scrollContainer]);

  if (location.pathname === "/redirect") {
    return <Redirect />;
  }

  if (location.pathname === "/auth/callback") {
    return <AuthCallback />;
  }

  if (location.pathname.startsWith("/request-delete-account/")) {
    return (
      <Routes>
        <Route
          path="/request-delete-account/:id"
          element={<DeleteAccountRequestPage />}
        />
      </Routes>
    );
  }

  return (
    <>
      <URLRedirectHandler />
      <AppDownloadGate />

      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/dados-pessoais"
            element={<AccountPage section="personal" />}
          />
          <Route
            path="/preferencias-notificacao"
            element={<AccountPage section="notifications" />}
          />
          <Route
            path="/privacidade"
            element={<AccountPage section="privacy" />}
          />
          <Route
            path="/alertas"
            element={
              <RequireAuth>
                <AlertsListPage />
              </RequireAuth>
            }
          />
          <Route
            path="/alertas/novo"
            element={
              <RequireAuth>
                <AlertsCreatePage />
              </RequireAuth>
            }
          />
          <Route
            path="/alertas/:id/editar"
            element={
              <RequireAuth>
                <EditAlertPage />
              </RequireAuth>
            }
          />
          {shouldRender && <Route path="*" element={<Serp />} />}
        </Routes>
      </Layout>
    </>
  );
}
